const layoutColors = {
  grey: {
    base: "#9e9e9e",
    gradient: "linear-gradient(270deg, #fafafa 0%, #eeeeee 100%)",
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121"
  },
  blueGrey: {
    base: "#21333c",
    gradient: "linear-gradient(270deg, #455a64 0%, #21333c 100%)",
    50: "#eceff1",
    100: "#cfd8dc",
    200: "#b0bec5",
    300: "#90a4ae",
    400: "#78909c",
    500: "#607d8b",
    600: "#546e7a",
    700: "#455a64",
    800: "#37474f",
    900: "#263238"
  },
  support: {
    info: "#1976d2",
    infoGradient: "linear-gradient(181.2deg, #1976d2 3.01%, #0d47a1 88.99%)",
    success: "#8BC34A",
    successGradient: "linear-gradient(178.8deg, #8bc34a 8.86%, #33691e 94.84%)",
    error: "#f44336",
    errorGradient: "linear-gradient(180deg, #f44336 0%, #b71c1c 100%)",
    warn: "#ff9800",
    warnGradient: "linear-gradient(180deg, #ff9800 0%, #e65100 100%)",
    teal: "#00ffe7",
    tealGradient: "linear-gradient(180deg, #00ffe7 0%, #00665c 100%)",
    cian: "#009fe3",
    cianGradient: "linear-gradient(180deg, #009fe3 0%, #00618a 100%)",
    purple: "#5e1ae5"
  },
  neutral: {
    white: "#ffffff",
    black: "#000000"
  },
  semantic: {
    base: "#8bc34a",
    informative: "#1976D2",
    notice: "#FF9800"
  },
  indicators: {
    finished: "#607d8b",
    pending: "#ff9800",
    awaiting: "#1976d2",
    "in-progress": "#5e1ae5",
    installation: "#6EC782",
    reproved: "#F44336",
    promoters: "#8BC34A",
    neutrals: "#1976D2",
    detractors: "#F44336",
    blocked: "#ff9800",
    inactive: "#78909C",
    active: "#8BC34A",
    restricted: "#F44336"
  },
  gradientRedGreen: {
    1: "#D52D29",
    2: "#E54927",
    3: "#ED6E2D",
    4: "#F1B23F",
    5: "#F8D84A",
    6: "#E5E94D",
    7: "#DBF04E",
    8: "#C2E94A",
    9: "#ACDF4A",
    10: "#67C458"
  },
  services: {
    waiting: "#009fe3",
    approved: "#8BC34A",
    disapproved: "#f44336",
    abandoned: "#f44336",
    canceled: "#f44336",
    pending: "#ff9800"
  },
  "status-info": {
    success: "#8BC34A",
    "in-progress": "#8E5FED",
    "in-queue": "#FFCC55",
    failed: "#F77B72"
  },
  "map-legend": {
    "red": "#FF0000",
    "yellow": "#FFFF00",
    "green": "#008000"
  }
}

export default layoutColors
